<template>
  <div v-if="body_show">
    <div class="task_f" v-html="introduce"></div>
    <div class="valuation">
      <div class="valuation_content" v-html="content"></div>
    </div>
  </div>
</template>
<script>
import {
  getvaluation
} from "@/api/course";
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        body_show: false,
        introduce: "",
        content: "",
      }
    },
    methods: {
      pullData() {
        getvaluation({
            cid: this.$route.query.cid,
            cpid: this.$route.query.cpid
          })
          .then((data) => {
            this.body_show = true;
            this.content = data.content;
            this.introduce = data.introduce;
            // 神策统计--大神导师团
            sensors.track('projectWorkbox', {
              course_id: this.$route.query.cid,
              course_name: data.coursename,
              project_id: this.$route.query.cpid,
              project_name: data.projectname,
              workbox_type: "大神导师团",
              workbox_name: "大神导师团",
            });
          })

      }
    },
    created() {
      this.pullData();
      shareCon("course",this);
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.task_f {
  margin: 0 auto;
  text-align: left;
  width: 750px;
}

.valuation {
  text-align: left;
  background: #fff;
  padding: changeRem(.6)+px;
  width: 750px;
  margin-top: changeRem(.6)+px;
  .valuation_content {
    margin: 0 auto;
    width: 100%;
  }

}
</style>
<style>
   img {
    width: 100%
  }
</style>